import { Col, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { uniqueID } from '../../../utilz';
import { routeFileSelector } from '../../../utilz/i18n';
import Button from './Button';

const SaveCancelButtons = ({ onSave = () => {}, onCancel = () => {}, lightMode, primaryBtnType = 'submit' }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  return (
    <Row gutter={16}>
      <Col>
        <Button
          id={uniqueID()}
          type="primary"
          variant="success"
          buttonType={primaryBtnType}
          lightMode={lightMode}
          {...(onSave ? { onClick: onSave } : {})}
        >
          {t('translation:default.buttons.save')}
        </Button>
      </Col>
      <Col>
        <Button
          id={uniqueID()}
          type="default"
          variant="danger"
          buttonType="button"
          onClick={onCancel}
          lightMode={lightMode}
        >
          {t('translation:default.buttons.cancel')}
        </Button>
      </Col>
    </Row>
  );
};

export default SaveCancelButtons;
